module.exports = __webpack_public_path__ + "static/media/fivetran-logo.18cae787.svg";